import React from "react";

import { sortBy } from "lodash";
import AccordionWrapper from "react-faq-component";

type AccordionDatum = { content: JSX.Element; title: string };

export interface UtmAccordionProps {
  readonly data: AccordionDatum[];
}

/* TODO: Eventually, we may want to generalize this (primarily as it relates
   to styling) for other existing or potential uses in the application.  For
   now, it is just used for the UTM Guide. */
export const UtmAccordion = ({ data }: UtmAccordionProps): JSX.Element => (
  <AccordionWrapper
    data={{
      rows: sortBy(data, (n) => n.title.toLowerCase()),
    }}
    styles={{
      bgColor: "white",
      rowContentTextSize: "16px",
      rowContentPaddingTop: "0px",
      rowContentPaddingBottom: "6px",
      rowContentPaddingLeft: "20px",
      rowContentPaddingRight: "20px",
      arrowColor: "black",
    }}
    config={{ tabFocus: true }}
  />
);
